import { useEffect, useState } from "react";

export const useFetchAllProductSettings = (distributorId) => {
    const [productSettings, setProductSettings] = useState(null);

    useEffect(() => {
        const fetchAllProductSettings = async () => {
            // Matches OBO1's distributor_edit.aspx: its Availability filter defaults to "ALL", showing
            // both active and inactive SKUs (only archived items are excluded).
            const rsp = await fetch(`api/products/settings?onlyActiveProducts=false&distributorId=${distributorId}`);

            setProductSettings(rsp.ok ? await rsp.json() : []);
        }
        fetchAllProductSettings();
    }, [distributorId])

    return productSettings;
}
